import { getCompanyData } from "../../utils";
import { Button } from "@almafintech/react-components/Button";
import Container from "../Container/Container";
import Layout from "../Layout/Layout";
import errorIcon from "../../assets/images/icons/ui/ui-icon-error.svg";

import styles from "./ErrorPage.module.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { texts } from "./i18n";
import { useAppSelector } from "../../app/hooks";

// HACK: Error mapping in this page was just tacked on so this page could be
// reused for the interactive broker's onboarding error. It used to just be used
// for expired link errors. Might merit some refactoring later.

type Error = "LINK_ERROR" | "INTERACTIVE_BROKERS_ERROR";

const ErrorPage = () => {
  const { errorContainer, body, companyLogo, footer } = styles;

  const {
    onboardingData: { language = "es" },
    activeTemplate: { onboardingType },
  } = useAppSelector((state) => state);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const error = (searchParams.get("error") as Error) ?? "LINK_ERROR";

  // TO DO: send email to user with new link
  const handleResendLink = () => {};

  const handleRetryInteractiveBrokers = () =>
    navigate("/terminos-y-condiciones");

  return (
    <Layout
      hideLogo
      hideSupportButton
      hideStepper={onboardingType === "INTERACTIVE_BROKERS"}
    >
      <Container className={errorContainer}>
        <img
          className={companyLogo}
          src={getCompanyData().logo}
          alt={`${getCompanyData().companyName} logo`}
          width={160}
        />
        <div className={body}>
          <img src={errorIcon} alt="error" />

          {error === "LINK_ERROR" && (
            <>
              <h1>El enlace para el registro ya no es válido.</h1>
              <p>Solicita uno nuevo para finalizar tu registro.</p>
              <Button
                text="Solicitar nuevo enlace"
                onClick={handleResendLink}
              />
            </>
          )}

          {error === "INTERACTIVE_BROKERS_ERROR" && (
            <>
              <h1>{texts[language].interactiveBrokers.title}</h1>
              <p>{texts[language].interactiveBrokers.description}</p>
              <Button
                text={texts[language].interactiveBrokers.button}
                onClick={handleRetryInteractiveBrokers}
              />

              <p className={footer}>
                {texts[language].interactiveBrokers.footer}
              </p>
            </>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default ErrorPage;
